export const Types = {
    SAVE_LIST_SOLUTIONS: 'SAVE_LIST_SOLUTIONS',
  
}